// @flow
import type { EnvironmentConfig } from 'model/EnvironmentConfig';

export default (): EnvironmentConfig => ({
  atlAdminUrl: 'https://admin.atlassian.com',
  clicktaleEnabled: true,
  hamsUrl: 'https://www.atlassian.com/hamlet',
  idLoginUrl: 'https://id.atlassian.com/login',
  logoutUrl: () =>
    `https://id.atlassian.com/logout?continue=${encodeURIComponent(document.location.href)}`,
  marketplaceUrl: 'https://marketplace.atlassian.com',
  padresUrl: 'https://marketplace.atlassian.com/padres',
  paypal: {
    env: 'production',
  },
  segmentKey: 'kiv6wyh2nw',
  sentry: {
    environment: 'prod',
  },
  wacUrl: 'https://www.atlassian.com',
  wacPurchaseLicensingUrl: 'https://www.atlassian.com/licensing/purchase-licensing',
  wacLicensingUrl: 'https://www.atlassian.com/licensing',
  i18nUrl: 'https://cart-static.us-east-1.prod.public.atl-paas.net/i18n',
  cloudMigrationToolsUrl: 'https://api-private.atlassian.com/cloud-migration-tools',
  root: 'https://www.atlassian.com/purchase',
  partnerPortal: 'https://partners.atlassian.com',
  intercomAppID: 'odnoznr4',
  adminHubUrl: 'https://admin.atlassian.com',
  statsigClientSDK: 'aaf4c849-51e4-4db0-94b3-38c905cf060b',
  emailMAC: (userEmail) =>
    `https://id.atlassian.com/login?application=mac&continue=https://id.atlassian.com/manage-profile&prompt=none&login_hint=${userEmail}`,
  billingDetailsMAC: 'https://www.atlassian.com/purchase/my/edit-details',
  switchUserMAC: 'https://www.atlassian.com/purchase/my/config',
  switchAccountMAC:
    'https://id.atlassian.com/login?application=mac&continue=https://www.atlassian.com/purchase/my&prompt=select_account',
  logOutMAC:
    'https://id.atlassian.com/logout?application=mac&continue=https://www.atlassian.com/purchase/my',
  calculatePricingURL: 'https://www.atlassian.com/migration/assess/calculate-pricing',
  ppcUrl: 'https://ppc.atlassian.com',
  companyContact: 'https://www.atlassian.com/company/contact',
  legalCustomerAgreement: 'https://www.atlassian.com/legal/customer-agreement',
  profileAction: 'https://id.atlassian.com/profile/profile.action',
  support: 'https://support.atlassian.com',
  bitbucketCmtUrl: 'https://bitbucket.org/',
  applicationFormLink: (orgId) => `https://credit-request.atlassian.com/${orgId}?source=HAMS`,
  migrationLink: 'https://www.atlassian.com/migration',
  omniChannelGraphQLUrl: 'https://www.atlassian.com/gateway/api/graphql',
  omniChannelFlowId: 'd1b2f1eb-a575-40e2-85fc-bae29277e134',
  omniChannelEnvironment: 'production',
});
